import React, {useState} from "react";
import {Card, Collapse} from "reactstrap";
import {TableFilterEdit} from "./TableFilterEdit";
import {removeFilter, useTableFiltersDispatch} from "../../context/table_filters/TableFiltersIndex";

export const TableFilter = ({filter, entity}) => {
  const dispatch = useTableFiltersDispatch();
  const [collapse, setCollapse] = useState(true);

  const handleCollapse = () => {
    setCollapse(!collapse);
  }

  const filterToText = () => {
    return `${parseLabel()} ${parseOperator()} ${parseValue()}`;
  }

  const parseLabel = () => {
    if (filter.type === 'properties') {
      return filter.property
    }
    return filter.label
  }

  const parseOperator = () => {
    if (filter.type === 'string' && filter.operator === '=') {
      return 'equals'
    }
    if (filter.type === 'string' && filter.operator === '!=') {
      return 'not equals'
    }
    return filter.operator.toLowerCase();
  }

  const parseValue = () => {
    if (filter.operator === 'IS NULL' || filter.operator === 'IS NOT NULL') {
      return '';
    }
    if (filter.type === 'string' || filter.type === 'properties') {
      return `'${filter.value.replaceAll('%', '')}'`;
    }
    if (filter.type === 'money') {
      return `${filter.value / 1000}`;
    }
    if (filter.type === 'role') {
      const roleMap = {
        user: {
          'admin': 'Admin',
          'user': 'User',
        },
        user_access: {
          'owner': 'Owner',
          'admin': 'Admin',
          'collaborator': 'Collaborator',
          'viewer': 'Viewer'
        }
      }
      if (roleMap[entity] && roleMap[entity][filter.value] !== undefined) {
        return roleMap[entity][filter.value];
      }
    }
    if (filter.type === 'status') {
      // Status value text mapping by entity type
      const statusMap = {
        // Default status texts
        default: {
          0: 'Paused',
          1: 'Active',
          2: 'Deleted',
          3: 'Manually Disabled'
        },
        // User-specific status texts
        user: {
          0: 'Disabled',
          1: 'Active',
          2: 'Deleted',
          3: 'Locked',
          4: 'Invited',
          5: 'Needs Confirmation'
        },
        // User-access status texts
        user_access: {
          0: 'Disabled',
          1: 'Active',
          2: 'Deleted',
          3: 'Locked',
          4: 'Invited',
          5: 'Needs Confirmation'
        },
        // Product-specific status texts
        product: {
          0: 'Disabled',
          1: 'Active',
          2: 'Deleted',
          3: 'Manually Disabled'
        }
      };

      // Get status value as integer
      const statusValue = parseInt(filter.value, 10);

      // Check if we have a mapping for this entity and status value
      if (statusMap[entity] && statusMap[entity][statusValue] !== undefined) {
        return statusMap[entity][statusValue];
      }

      // Special case: if status is 4 or 5, it's almost certainly a user status
      if (statusValue === 4) return 'Invited';
      if (statusValue === 5) return 'Needs Confirmation';

      // Fall back to default status map
      return statusMap.default[statusValue] || filter.value;
    }
    if (filter.type === 'role') {
      // Basic User role mapping
      const roleMap = {
        'admin': 'Admin',
        'user': 'User'
      };
      return roleMap[filter.value] || filter.value;
    }
    return filter.value
  }

  const handleRemoveClick = () => {
    removeFilter(dispatch, filter.id);
  }

  return (
    <>
      <div className="md-chip me-2">
        <div className="md-chip-clickable" onClick={handleCollapse}>
          <span>{filterToText()}</span>
          <button type="button" className="md-chip-remove" onClick={handleRemoveClick}></button>
        </div>
        <Collapse isOpen={!collapse} className="filter_selector edit">
          <Card>
            <TableFilterEdit
              filter={filter}
              closeDialog={() => setCollapse(true)}
              entity={entity}
            />
          </Card>
        </Collapse>
      </div>
    </>
  )
}
